<template>
    <div class="spot-card">
        <router-link class="card" :class="{ active_: selected }"
                     :to="{ name: 'spot', params: { id: spot.id } }">
            <div class="thumbnail" :style="spot.images[0] | bgstyle"></div>
            <div class="right">
                <p class="type">{{type}}</p>
                <h1 class="name">{{spot.name}}</h1>
                <p class="coupon" v-if="hasCoupon">
                    <img src="~@/assets/icon-coupon.svg">
                    <span v-if="spot.couponCond">{{spot.couponCond}}</span>
                    <b v-if="spot.couponDiscount" class="coupon__discount">{{spot.couponDiscount}}</b>
                </p>
                <p class="oneliner">{{spot.oneliner}}</p>
            </div>
        </router-link>
    </div>
</template>

<script>
import { spotTypeShort } from '@/core/type'

export default {
    name: 'SpotCard',
    props: {
        spot: null,
        selected: Boolean
    },
    computed: {
        type() {
            return spotTypeShort(this.spot.type)
        },
        hasCoupon() {
            return this.spot.couponCond || this.spot.couponDiscount
        },
    },
}
</script>

<style scoped lang="scss">
@import '~@/styles/_parts';

.spot-card {
    height: em(130);
}
.card {
    height: 100%;
    background: #fff;
    background-size: auto em(115);
    border: 1px solid #342264;
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.5);
    color: #342264;
    display: flex;
    position: relative;
    transition: background-color 195ms $ease, color 195ms $ease;
    &.active_ {
        @include media(640) {
            background-color: #342264;
            color: #efefef;
        }
    }
}

.thumbnail {
    width: em(113);
    height: em(128);
    background: center no-repeat;
    background-size: cover;
    flex-shrink: 0;
}

.right {
    height: 100%;
    flex-grow: 1;
    padding: em(8) em(8) em(8) em(12);
    position: relative;
}

.name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: em(15);
    font-weight: 800;
    margin-top: em(4);
    word-break: keep-all;
}
.type {
    float: right;
    font-family: 'Fugaz One', sans-serif;
    font-size: em(12);
    line-height: 1.15;
    margin-top: em(8, 12);
    text-align: right;
    text-transform: uppercase;
}

.coupon {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background-size: 2em 2em;
    font-size: em(12);
    font-weight: 300;
    margin-top: em(2, 12);
    padding-top: em(4, 12);
    word-break: keep-all;
}
.coupon__discount {
    margin-left: .6ch;
}

.oneliner {
    font-size: em(12);
    line-height: em(16, 12);
    position: absolute;
    right: em(8, 12);
    left: em(12, 12);
    bottom: em(12, 12);
    word-break: keep-all;
}
</style>